import React, { useMemo, useEffect } from 'react';
import classnames from 'classnames';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Collapse,
  CardBody,
  Card,
  Tooltip,
  Label,
  Input,
  Badge,
  UncontrolledCollapse,
  ButtonGroup,
  CardFooter,
} from 'reactstrap';
import axios from 'axios';

import ConnectriaTicketsService from '../../services/ConnectriaTicketsService';
import CookieService from '../../services/CookieService';
import PortalService from '../../services/PortalService';
import useTriaTicketsState, { createdBy } from './ConnectriaTicketsState';
import {appState} from "../../AppState";
import useAsyncEffect from "../../utility/use-async-effect";

import FileService from '../../services/FileService';
import { timezone } from '../../utility/DateUtil';

var moment = require('moment-timezone');

const ConnectriaResponseRating = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [rating, setRating] = useState(null);
  const [comment, setComment] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const hasRating = props.userRatings.filter((e) => e.ticket_history_id == props.commentId);
  const toggle = (rating) => {
    setIsOpen(!isOpen);
    //if closing the rating and there is a historical value check for it first
    setRating(rating == null ? (hasRating.length > 0 ? hasRating[0].rating : null) : rating);
  };
  useEffect(() => {
    if (hasRating.length > 0) {
      setRating(hasRating[0].rating);
      setComment(hasRating[0].comment);
    }
  }, []);

  const doRating = async () => {
    let endpoint =
      hasRating.length > 0
        ? ConnectriaTicketsService.updateTicketCommentRating(hasRating[0].id, rating, comment)
        : ConnectriaTicketsService.createTicketCommentRating(props.commentId, rating, comment);
    setIsLoading(true);
    let result = await endpoint;
    setIsLoading(false);
    toggle(rating);
  };
  const deleteRating = async () => {
    setIsLoading(true);
    let result = await ConnectriaTicketsService.deleteTicketCommentRating(hasRating[0].id);
    toggle(0);
    setIsLoading(false);
  };
  return (
    <div
      className={'p2 row '}
      style={{
        backgroundColor: '#e9e9e9',
        paddingLeft: 12 + 'px',
        borderTop: 0.0625 + 'rem solid #d5d9dd',
      }}
    >
      <p className="w-100">
        Was the following response helpful? Click here to rate:
        <div className="parent">
          <span
            id="rating-1"
            onClick={() => toggle(1)}
            className={(rating >= 1 ? 'fas rated' : 'far') + ' fa-star comment-rating'}
          ></span>
          <span
            id="rating-2"
            onClick={() => toggle(2)}
            className={(rating >= 2 ? 'fas rated' : 'far') + ' fa-star comment-rating'}
          ></span>
          <span
            id="rating-3"
            onClick={() => toggle(3)}
            className={(rating >= 3 ? 'fas rated' : 'far') + ' fa-star comment-rating'}
          ></span>
          <span
            id="rating-4"
            onClick={() => toggle(4)}
            className={(rating >= 4 ? 'fas rated' : 'far') + ' fa-star comment-rating'}
          ></span>
          <span
            id="rating-5"
            onClick={() => toggle(5)}
            className={(rating >= 5 ? 'fas rated' : 'far') + ' fa-star comment-rating'}
          ></span>
        </div>
        <Collapse isOpen={isOpen} className="pr-1">
          <Card>
            <CardBody>
              <Input
                type="textarea"
                rows="4"
                onChange={(e) => setComment(e.target.value)}
                className="w-100 form-control"
                value={comment}
                placeholder="Add a comment about the quality of support you received."
              ></Input>
            </CardBody>
            <CardFooter>
              <div className="text-right">
                {hasRating.length > 0 ? (
                  <span
                    style={{ lineHeight: 35.6 + 'px' }}
                    className="pull-left cursor"
                    onClick={() => {
                      if (window.confirm('Are you sure you wish to delete this rating?')) deleteRating();
                    }}
                  >
                    [ remove my rating ]
                  </span>
                ) : (
                  <></>
                )}
                <Button type="button" onClick={() => toggle(null)} className="btn-sm btn-danger">
                  Close
                </Button>
                <Button disabled={isLoading} type="button" onClick={() => doRating()} className="btn-sm">
                  Submit
                </Button>
              </div>
            </CardFooter>
          </Card>
        </Collapse>
      </p>
    </div>
  );
};

function HistoryItem(props) {
  const [stateApp, stateAppActions] = appState();

  let momentTzGuess = moment.tz.guess();
  let commentCreatedTs = props.comment.created;
  let created = moment(commentCreatedTs, 'YYYY-MM-DDThh:mm:ss.SSSZ').tz(momentTzGuess).format('LLL z');

  //if the ticket wasn't created by Connectria assume all commenters from Connectria are "left-side"
  if (props.ticket.customer_id > 0) {
    return (
      <div key={props.index} className={`mt-2 ${props.comment.user.customer_id > 0 ? 'text-left' : 'text-left'}`}>
        <div className="p-2 row" style={{ backgroundColor: '#e9e9e9', paddingBottom: 0 + 'px !important' }}>
          <div style={{ width: 90 + '%' }} className="col">
            <p className="  mb-0">
              Comment by:{' '}
              <span style={{ textTransform: 'capitalize', fontWeight: 700 }}>{createdBy(props.comment.user)}</span> of{' '}
              <span style={{ fontWeight: 700 }}>
                {props.comment.user.customer_id > 0 ? stateApp.userInfo.organization_name : 'Connectria'}
              </span>
            </p>

            <p className=" mb-0">{created}</p>
          </div>
          <div style={{ maxWidth: 10 + '%' }} className="col center-flex-item">
            {props.comment.user.customer_id == 0 ? (
              <img
                style={{ width: 30 + 'px' }}
                src="data:image/png;base64,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"
              ></img>
            ) : (
              <></>
            )}
          </div>
        </div>
        {props.comment.user.customer_id == 0 ? (
          <ConnectriaResponseRating
            userRatings={props.userRatings}
            commentId={props.comment.id}
          ></ConnectriaResponseRating>
        ) : (
          <></>
        )}
        <p className="pb-3 pt-1" style={{ fontSize: 0.97 + 'rem', whiteSpace: 'pre-wrap' }}>
          {props.comment.comment}
        </p>
      </div>
    );
  } else {
    //created by connectria. if comment comes from a different team assume it's "left-side"
    return (
      <div
        key={props.index}
        className={`mt-2 ${props.comment.user.primary_team_id != props.ticket.team_id ? 'text-left' : 'text-left'}`}
      >
        <p>{props.comment.comment}</p>
        <blockquote className={`primary ${props.comment.user.primary_team_id != props.ticket.team_id ? 'right' : ''}`}>
          {createdBy(props.comment.user)} - {moment(props.comment.created, 'YYYY-MM-DDThh:mm:ss.SSSZ').calendar()}
        </blockquote>
      </div>
    );
  }
}

const TicketHistories = (props) => {
  const [isHistoryLoading, setIsHistoryLoading] = useState(true);
  const [historiesMounted, setHistoriesMounted] = useState(false);
  const [history, setHistory] = useState(null);
  const [historyRatings, setHistoryRatings] = useState([]);
  const source = axios.CancelToken.source();

  useEffect(() => {
    setHistoriesMounted(true);
    return () => {
      setHistoriesMounted(false);
    };
  }, []);

  useAsyncEffect(
    async (isMounted) => {
      try {
        if (!historiesMounted) return;
        setIsHistoryLoading(true);

        let [history, ratings] = await Promise.all([
          ConnectriaTicketsService.ticketHistory(props.ticketId, { cancelToken: source.token }),
          ConnectriaTicketsService.getTicketCommentRatings(props.ticketId, { cancelToken: source.token }),
        ]);

        if (!isMounted()) return;
        setHistoryRatings(ratings);
        setHistory((history || []).filter((e) => e.pvt == false));
        setIsHistoryLoading(false);
        if (props.setCacheBuster) {
          props.setCacheBuster(false);
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          // request cancelled
          console.log('canceled');
        } else {
          throw error;
        }
      }
    },
    () => {
      console.log('unmount canceled');
      source.cancel();
    },
    [historiesMounted, props.cacheBuster]
  );

  if (isHistoryLoading) {
    return (
      <div className="text-center">
        <i className="fas fa-spinner m-3 mt-4 fa-spin" style={{ fontSize: '30px' }}></i>
      </div>
    );
  } else {
    return (
      <>
        {history == null || history.length == 0 ? (
          <div></div>
        ) : (
          history.map((item, index) => {
            return (
              <HistoryItem
                userRatings={historyRatings}
                index={index}
                comment={item}
                ticket={props.ticket}
                key={index}
              ></HistoryItem>
            );
          })
        )}
      </>
    );
  }
};

const FileTypeIcon = (props) => {
  var filenameSplit = props.filename.split('.');
  switch (filenameSplit[filenameSplit.length - 1].toLowerCase()) {
    case 'pdf':
      return <i className="fa fa-file-pdf"></i>;
    case 'txt':
      return <i className="fa fa-file-alt"></i>;
    case 'gif':
    case 'jpg':
    case 'jpeg':
    case 'tif':
    case 'png':
      return <i className="fa fa-file-image"></i>;
    case 'doc':
    case 'docx':
    case 'docm':
      return <i className="fa fa-file-word"></i>;
    case 'xls':
    case 'xlsx':
    case 'xlsm':
      return <i className="fa fa-file-excel"></i>;
    default:
      return <i className="fa fa-file"></i>;
  }
};
function saveData(blob, fileName) {
  // does the same as FileSaver.js
  var a = document.createElement('a');
  document.body.appendChild(a);
  a.style = 'display: none';

  var url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
}
const Attachment = (props) => {
  const [downloading, setDownloading] = useState(false);

  const download = async (e, file) => {
    setDownloading(true);
    if (e) {
      e.preventDefault();
    }
    let attachmentUrl = await ConnectriaTicketsService.getAttachmentUrl(props.ticketId, file.id);
    //THIS IS SEANS TEST DELETE LATER
    var xhr = new XMLHttpRequest();
    xhr.open('GET', attachmentUrl);
    xhr.responseType = 'blob';

    xhr.onload = function () {
      saveData(this.response, file.filename); // saveAs is a part of FileSaver.js
    };
    xhr.send();
    //THIS IS SEANS TEST UNCOMMENT LATER
    //  window.open(attahcmentUrl, "_blank");

    setDownloading(false);
  };

  return (
    <a
      onClick={(e) => {
        download(e, props.file);
      }}
    >
      <div className="attachment-block rounded">
        <FileTypeIcon filename={props.file.filename} className="attachment-icon"></FileTypeIcon>
        <div>
          <h4>{props.file.filename}</h4>
          <small>{moment(props.file.created, 'YYYY-MM-DDThh:mm:ss.SSSZ').calendar()}</small>
        </div>
        <div style={{ margin: 'auto' }}>{downloading ? <i className="fas fa-2x fa-spinner fa-spin"></i> : <></>}</div>
      </div>
    </a>
  );
};

const TicketAttachmentList = (props) => {
  return (
    <>
      {props.ticket.ticket_attachments == null || props.ticket.ticket_attachments.length == 0 ? (
        <div className="text-center mt-4 text-bold">
          <i className="fas fa-exclamation-triangle"></i> No Attachments
        </div>
      ) : (
        <>
          {props.ticket.ticket_attachments.map((file, index) => {
            return <Attachment ticketId={props.ticketId} file={file} key={index}></Attachment>;
          })}
        </>
      )}
    </>
  );
};

const TicketCloseForm = (props) => {
  //local
  const [isClosing, setIsClosing] = useState(false);
  const [closeRating, setCloseRating] = useState(6);
  const [closeComment, setCloseComment] = useState('');
  //global state
  const [stateApp, stateAppActions] = appState();
  //plugin state
  const [stateTickets, stateTicketActions] = useTriaTicketsState();
  const history = useHistory();

  const closeTicket = async (comment) => {
    await ConnectriaTicketsService.closeTicket(props.id, comment, closeRating);
    //remove ticket from state and update UI
    stateTicketActions.removeTicket(props.id);
    stateAppActions.setAlert({
      content: <p style={{ color: 'white' }}>Ticket #{props.id} closed.</p>,
      className: 'success',
      visible: true,
    });
    setTimeout(() => {
      stateAppActions.setAlert((prevState) => ({ ...prevState, visible: false }));
    }, 2000);
  };

  const handleClose = async (e) => {
    if (e) {
      e.preventDefault();
    }
    setIsClosing(true);
    try {
      if (props.reopen) {
        await ConnectriaTicketsService.reopenTicket(props.id, closeComment);
        //clear tickets to reset state
        stateTicketActions.setTicketStatus(props.id, 'Open');
        //stateTicketActions.setTicketDetail({});
        props.setReloadDetail(true);
      } else {
        const comment = closeComment == '' ? 'Closed' : closeComment;
        await closeTicket(comment);
        // let ifChildTickets = await ConnectriaTicketsService.getChildTicket(props.id)
        // console.log(ifChildTickets)
        // if (ifChildTickets['data']['response']['data'].hasOwnProperty('tickets') && ifChildTickets['data']['response']['data']['tickets'].length > 0) {
        //   console.log('yes there are child tickets')
        //   let availableChildTicket = ifChildTickets['data']['response']['data']['tickets'].filter(ticket => {
        //         return ticket['status'].toLowerCase() === 'open'
        //             || ticket['status'].toLowerCase() === 'new'
        //             || ticket['status'].toLowerCase() === 'waitoncust'
        //             || ticket['status'].toLowerCase() === 'input required'
        //     })
        //   console.log("open child ticket are ")
        //   console.log(availableChildTicket)
        //   if (availableChildTicket.length > 0){
        //     stateAppActions.setAlert({
        //     content: <p style={{color: "white"}} >Ticket #{props.id} cannot be closed. Please try closing this ticket again later.</p>,
        //     color: "danger",
        //     visible: true
        //   });
        //   setTimeout(() => {
        //         stateAppActions.setAlert(prevState => ({...prevState, visible: false }))
        //       }, 10000);
        //   } else {
        //     await closeTicket(comment)
        //   }
        // } else {
        //   await closeTicket(comment)
        // }

        // reload ticket after close
        props.setReloadDetail(true);
      }
    } catch (error) {
      console.log(error);
      stateAppActions.setBlade({
        visible: false,
        content: '',
        title: '',
      });
      stateAppActions.setAlert({
        content: <p style={{ color: 'white' }}>Error updating ticket.</p>,
        className: 'danger',
        visible: true,
      });
    }
  };

  return (
    <form className="mt-3" onSubmit={(e) => handleClose(e)}>
      <Label>
        <strong>Reason and Rating</strong>
      </Label>
      <p>
        How would you rate the support you received?{' '}
        {!props.reopen && (
          <span className="pl-2">
            <Button
              className={`btn-sm ${closeRating === 6 ? '' : 'btn-simple'}`}
              onClick={() => setCloseRating(6)}
              active={closeRating === 6}
              color="primary"
              style={{ border: '1px solid', borderColor: closeRating === 6 ? 'transparent' : '' }}
            >
              <i className="far fa-thumbs-up"></i>
            </Button>
            <Button
              className={`btn-sm ${closeRating === 3 ? '' : 'btn-simple'}`}
              onClick={() => setCloseRating(3)}
              active={closeRating === 3}
              color="primary"
              style={{ border: '1px solid', borderColor: closeRating === 3 ? 'transparent' : '' }}
            >
              <i className="far fa-thumbs-down"></i>
            </Button>
          </span>
        )}
      </p>
      <hr></hr>
      <Input
        type="textarea"
        placeholder={
          props.reopen ? 'Re-Open Comment' : 'Please add a reason why this ticket is being closed (optional).'
        }
        onChange={(e) => setCloseComment(e.target.value)}
        rows="4"
        value={closeComment}
      ></Input>
      {/* {!props.reopen &&
                <>
                    <Button className="btn-sm" color="primary" onClick={() => setCloseRating(6)} active={closeRating === 6}><i className="far fa-thumbs-up"></i></Button>
                    <Button className="btn-sm" color="primary" onClick={() => setCloseRating(7)} active={closeRating === 7}><i className="far fa-thumbs-down"></i></Button>
                </>
            } */}
      <div className="text-right mt-2">
        {isClosing ? (
          <Button type="submit" disabled={isClosing} className="btn-sm">
            <i className="fas fa-spinner fa-spin ml-1" style={{ fontSize: '15px' }}></i>Submit
          </Button>
        ) : (
          <>
            {!props.reopen && (
              <Button type="submit" className="btn-sm">
                Submit
              </Button>
            )}
            {props.reopen && (
              <Button type="submit" disabled={closeComment.trim().split(/[\s\n]+/).length < 4} className="btn-sm">
                Submit
              </Button>
            )}
          </>
        )}
      </div>
    </form>
  );
};

const ConvertedDeviceId = (props) => {
  const [assetTag, setAssetTag] = useState(props.deviceId);
  const source = axios.CancelToken.source();

  useAsyncEffect(
    async (isMounted) => {
      try {
        var reg = new RegExp(/^\d+$/);

        if (reg.test(props.deviceId)) {
          let devices =
            (await ConnectriaTicketsService.getAllDevicesLike({
              ar_assoc: 'devicetype',
              limit: 100,
            })) || [];

          for (var i = 0; i < devices.length; i++) {
            if (devices[i].id == props.deviceId) setAssetTag(devices[i].assettag);
          }
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          // request cancelled
        } else {
          throw error;
        }
      }
    },
    () => {
      source.cancel();
    },
    []
  );

  return <span>{assetTag}</span>;
};

const CCForm = (props) => {
  return (
    <>
      <Label>
        <strong>Edit Ticket CC</strong>
      </Label>
      <div className="form-control" style={{ overflowY: 'scroll', height: 100 + 'px', minHeight: 100 + 'px' }}>
        {props.ccUsers.map((user, index) => (
          <div
            className={'d-flex w-100'}
            key={index}
            onClick={() => {
              props.handleCCSelect(user);
            }}
            style={{ backgroundColor: user.selected ? 'lightblue' : '', cursor: 'pointer' }}
          >
            <p style={{ flex: '0 50%' }}>{user.fname + ' ' + user.surname}</p>
            <p style={{ flex: '0 50%' }}>{'<' + user.email + '>'}</p>
          </div>
        ))}
      </div>
      {props.showCcCsm && (
        <div className="position-relative form-check ">
          <label className="form-check-label">
            <nobr>cc {props.csmInfo.user.fname + ' ' + props.csmInfo.user.surname}</nobr>
            <input
              type="checkbox"
              className="form-check-input"
              checked={props.includeCSM}
              onChange={props.handleCsmSelect}
            />
            <span className="form-check-sign">
              <span className="check"></span>
            </span>
          </label>
        </div>
      )}
      <Button
        className="btn-sm"
        style={{ minHeight: 18 + 'px' }}
        onClick={() => {
          props.handleCCSave();
        }}
      >
        Save CC
      </Button>
      <div className="mb-3"></div>
    </>
  );
};

const EditTicketDescription = (props) => {
  const [description, setDescription] = useState(props.detail.issue);
  const [editMode, setEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  if (['New', 'Open', 'WaitOnCust'].indexOf(props.detail.status) === -1) {
    // show basic header without editing feature
    return (
      <div id="taDescription" className="mt-1 flex-grow-1 rounded mb-3">
        {props.detail.issue}
      </div>
    );
  }

  const save = async (e) => {
    if (props.detail.issue !== description) {
      setEditMode(false);
      setIsLoading(true);
      await ConnectriaTicketsService.updateTicket(props.detail.id, { issue: description });
      setIsLoading(false);

      ConnectriaTicketsService.clearTicketCache();
      props.setReloadDetail(true);
    }
  };

  if (isLoading) {
    return (
      <div className="text-center">
        <i className="fas fa-spinner m-3 mt-4 fa-spin" style={{ fontSize: '30px' }} />
      </div>
    );
  } else if (editMode) {
    return (
      <textarea
        value={description}
        className="form-control rounded"
        rows="10"
        onChange={(e) => {
          setDescription(e.target.value);
        }}
        onBlur={(e) => save(e)}
      />
    );
  } else {
    return (
      <div id="taDescription" onClick={() => setEditMode(true)} className="mt-1 flex-grow-1 rounded mb-3">
        {props.detail.issue}
      </div>
    );
  }
};

const BladeTabDetail = (props) => {
  const source = axios.CancelToken.source();
  const [closeFormVisible, setCloseFormVisible] = useState(false);
  const [reopenFormVisible, setReopenFormVisible] = useState(false);
  const [convertedDevice, setConvertedDevice] = useState('');
  const [showCCForm, setShowCCForm] = useState(false);
  const [showCCSaveLoader, setCCSaveLoader] = useState(false);
  const [ccUsers, setCCUsers] = useState([]);
  const [includeCSM, setIncludeCSM] = useState(false);
  const [csmInfo, setCsmInfo] = useState({});
  const [showCcCsm, setShowCcCsm] = useState(false);
  const [notifyCsmMeta, setNotifyCsmMeta] = useState({});
  const [stateApp, stateAppActions] = appState();

  const momentTzGuess = moment.tz.guess();

  useAsyncEffect(
    async (isMounted) => {
      try {
        let isCustomer = stateApp.userInfo.organization_id != 0;
        console.log('Load ticket users');
        var users = await ConnectriaTicketsService.getAllUsersLike(
          {
            cancelToken: source.token,
          },
          isCustomer
        );
        let [accountAgents, metadata] = await Promise.all([
          ConnectriaTicketsService.getParamData({ cancelToken: source.token }),
          PortalService.getPortalCustomerMeta({ meta_key: 'tria_show_cc_csm' }),
        ]);
        users.sort((a, b) => {
          return a.fname.localeCompare(b.fname);
        });
        let existsCCUsers = props.detail.ticket_carbon_copies.map((item) => {
          return item.user_id;
        });
        setCCUsers(
          users.filter((user) => {
            user.selected = existsCCUsers.indexOf(user.id) > -1;
            return (
              user.active &&
              user.login_supported &&
              !user.serviceUser &&
              (props.detail.user.email !== stateApp.userInfo?.email || user.email !== stateApp.userInfo?.email)
            );
          })
        );

        accountAgents = accountAgents.dynamic.response.data.customer_account_agents || [];
        for (var agent of accountAgents) {
          if (agent.agent_type.name == 'Customer Success Manager') {
            setCsmInfo(agent);
          }
        }
        const notifyCsmTicketMeta = props.detail.meta.find((meta) => meta.meta_key == 'notify_csm');
        if (metadata.meta_value == 'TRUE') {
          setShowCcCsm(true);
          if (notifyCsmTicketMeta) {
            setNotifyCsmMeta(notifyCsmTicketMeta);
            setIncludeCSM(true);
          }
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          // request cancelled
        } else {
          throw error;
        }
      }
    },
    () => {
      source.cancel();
    },
    []
  );

  const handleCsmSelect = () => {
    setIncludeCSM(!includeCSM);
  };

  const handleCCSave = async () => {
    setShowCCForm(false);
    setCCSaveLoader(true);

    let selected_users = ccUsers.filter((user) => {
      return user.selected;
    });
    let selected_user_ids = selected_users.map((user) => {
      return user.id;
    });

    // delete unselected users
    let users = [];
    for (let item of props.detail.ticket_carbon_copies) {
      if (selected_user_ids.indexOf(item.user_id) > -1) {
        users.push(item);
      } else {
        await ConnectriaTicketsService.deleteTicketCarbonCopy(item.id);
      }
    }
    props.detail.ticket_carbon_copies = users;

    // add new users
    let exists_user_ids = props.detail.ticket_carbon_copies.map((user) => {
      return user.user_id;
    });
    for (let user of selected_users) {
      if (exists_user_ids.indexOf(user.id) == -1) {
        let cc = await ConnectriaTicketsService.saveTicketCarbonCopies(props.detail.id, [user.id]);
        props.detail.ticket_carbon_copies.push(cc[0]);
      }
    }
    // update user objects by user_id
    await ConnectriaTicketsService.updateUsersTicketCarbonCopies(props.detail);
    if (includeCSM && Object.keys(notifyCsmMeta).length == 0) {
      var response = await ConnectriaTicketsService.createTicketMeta(props.detail.id, 'notify_csm', 1);
      setNotifyCsmMeta(response.ticket_meta[0]);
      // Leave the checkbox checked
      setIncludeCSM(true);
    } else if (!includeCSM && Object.keys(notifyCsmMeta).length != 0) {
      await ConnectriaTicketsService.deleteTicketMeta(notifyCsmMeta.id);
      setNotifyCsmMeta({});
      // Leave the checkbox unchecked
      setIncludeCSM(false);
    }
    setCCSaveLoader(false);
  };

  const handleCCSelect = (selectedUser) => {
    let usersCopy = ccUsers;

    for (let user of usersCopy) {
      if (user.id == selectedUser.id) {
        console.log('selecting user');
        user.selected = !user.selected;
      }
    }

    setCCUsers(usersCopy.slice());
  };
  const getCustomerTicketId = (detail) => {
    let content = '';
    let curuium_id = props.detail.meta.filter((e) => e.meta_key == 'curium_sys_id');

    if (curuium_id.length > 0)
      content = (
        <tr>
          <td>Customer Ticket #:</td>
          <td>
            <span className="font-weight-bold">{curuium_id[0].meta_value}</span>
          </td>
        </tr>
      );

    return content;
  };
  return (
    <div id="paneDetails" className="flex-fill d-flex flex-column tab-pane">
      <blockquote className={`mt-3 blockquote ticket-${props.detail.status}`}>
        <table className="table table-sm table-borderless mb-0">
          <tbody>
            <tr>
              <td>Owner:</td>
              <td>
                <span className="font-weight-bold">{createdBy(props.detail.user)}</span>
              </td>
            </tr>
            <tr>
              <td>Created By:</td>
              <td>
                <span className="font-weight-bold">{createdBy(props.detail.enteredby)}</span>
              </td>
            </tr>
            <tr>
              <td>Created:</td>
              <td>
                <span className="font-weight-bold">
                  {moment(props.detail.created, 'YYYY-MM-DDThh:mm:ss.SSSZ').tz(momentTzGuess).format('LLL z')}
                </span>
              </td>
            </tr>

            {getCustomerTicketId()}

            <tr>
              <td className="align-top">CC:</td>
              <td style={{ whiteSpace: 'pre-wrap' }}>
                <span className="font-weight-bold">
                  {props.detail.ticket_carbon_copies
                    .map((item) => {
                      return ((item.user || {}).fname || '') + ' ' + ((item.user || {}).surname || '');
                    })
                    .join(', ')}
                </span>
                {props.detail.ticket_carbon_copies.length > 0 ? <br /> : null}
                <Button href="#" onClick={() => setShowCCForm(!showCCForm)} className="btn-sm">
                  Edit CC
                </Button>
              </td>
            </tr>
            <tr>
              <td>Type:</td>
              <td>
                <span className="font-weight-bold">
                  {ConnectriaTicketsService.ticketType(props.detail.ticket_type_id).name}
                </span>
              </td>
            </tr>
            <tr>
              <td>Priority:</td>
              <td>
                <span className="font-weight-bold">
                  {ConnectriaTicketsService.ticketPriority(props.detail.priority).name}
                </span>
              </td>
            </tr>
            <tr>
              <td>Status:</td>
              <td>
                <span className="font-weight-bold">
                  {props.detail.status == 'WaitOnCust' ? 'Input Required' : props.detail.status}
                </span>
              </td>
            </tr>
            <tr>
              <td>Category:</td>
              <td>
                <span className="font-weight-bold">{props.detail.ticketcategory.name}</span>
              </td>
            </tr>
            <tr>
              <td>Sub-Category:</td>
              <td>
                <span className="font-weight-bold">{props.detail.ticketcategory.subcategory}</span>
              </td>
            </tr>
            {props.detail.device != 'undefined' ? (
              <tr>
                <td>Device:</td>
                <td>
                  <span className="font-weight-bold">
                    <ConvertedDeviceId deviceId={props.detail.device}></ConvertedDeviceId>
                  </span>
                </td>
              </tr>
            ) : (
              <></>
            )}
          </tbody>
        </table>
      </blockquote>
      {showCCSaveLoader && (
        <>
          <div className="text-center">
            <i className="fas fa-spinner m-3 mt-4 fa-spin" style={{ fontSize: '30px' }}></i>
          </div>
        </>
      )}
      {showCCForm && (
        <>
          <CCForm
            ccUsers={ccUsers}
            handleCCSave={handleCCSave}
            handleCCSelect={handleCCSelect}
            showCcCsm={showCcCsm}
            csmInfo={csmInfo}
            includeCSM={includeCSM}
            notifyCsmMeta={notifyCsmMeta}
            handleCsmSelect={handleCsmSelect}
          ></CCForm>
        </>
      )}
      <Label className="mt-1">
        <strong>Ticket Actions</strong>
      </Label>
      {props.detail.status !== 'Closed' ? (
        <div>
          {props.detail.status === 'Resolved' && (
            <>
              <Button
                className="btn-sm"
                id="toggleReopen"
                disabled={closeFormVisible}
                onClick={(e) => setReopenFormVisible(!reopenFormVisible)}
              >
                Re-Open Ticket
              </Button>
            </>
          )}

          <Button id="toggleClose" className="btn-sm" disabled={reopenFormVisible}>
            Close Ticket
          </Button>
          <UncontrolledCollapse toggler="#toggleClose">
            <TicketCloseForm
              id={props.detail.id}
              setReloadDetail={props.setReloadDetail}
              reopen={false}
              fullPage={props.fullPage}
            ></TicketCloseForm>
          </UncontrolledCollapse>
          {props.detail.status == 'Resolved' && (
            <UncontrolledCollapse toggler="#toggleReopen">
              <TicketCloseForm
                id={props.detail.id}
                setReloadDetail={props.setReloadDetail}
                reopen={true}
                fullPage={props.fullPage}
              ></TicketCloseForm>
            </UncontrolledCollapse>
          )}
        </div>
      ) : (
        <div>
          <div className="alert alert-success w-auto">
            <i className="fas fa-check-circle" /> Ticket closed
          </div>
        </div>
      )}
      <Label className="mt-3">
        <strong>Description</strong>
      </Label>
      <EditTicketDescription detail={props.detail} setReloadDetail={props.setReloadDetail} />
      {props.detail.errorDesc.length > 0 ? (
        <>
          <Label className="mt-3">
            <strong>Error Description</strong>
          </Label>
          <div id="taDescription" style={{ whiteSpace: 'pre-wrap' }} className="mt-1 flex-grow-1 rounded mb-3">
            {props.detail.errorDesc}
          </div>
        </>
      ) : (
        <></>
      )}
      {(typeof props.showCommentsMsg == undefined ? true : props.showCommentsMsg) && (
        <p>*You can view ticket history in the Comments tab above.</p>
      )}
    </div>
  );
};

const BladeTabComments = (props) => {
  const [state, stateActions] = useTriaTicketsState();
  const [isPostingComment, setIsPostingComment] = useState(false);
  const [cacheBuster, setCacheBuster] = useState(true);
  const [attachments, setAttachments] = useState([]);
  const [newComment, setNewComment] = useState(state.commentText);
  const [attachmentError, setAttachmentError] = useState(null);

  let fileInput = document.querySelector('#fileNewComment');

  const changeCommentText = (text) => {
    setNewComment(text);
    setAttachmentError(null);
    stateActions.setCommentText(text);
  };

  const addAttachment = (e) => {
    let file = e.target?.files?.[0];

    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        // check 5mb limit for the file size
        setAttachmentError('File size limit exceeded.');
      } else {
        setAttachmentError(null);
        setAttachments([...attachments, file]);
      }

      e.target.value = '';
    }
  };

  const handleNewComment = async (e) => {
    if (e) {
      e.preventDefault();
    }
    setIsPostingComment(true);

    // save comment text
    await ConnectriaTicketsService.newComment(props.detail.id, newComment);

    // add attachments
    let hasAttachment = false;
    for (let attachment of attachments) {
      hasAttachment = true;
      let content = await FileService.toBase64(attachment);
      await ConnectriaTicketsService.addAttachment(props.detail.id, attachment.name, content);
    }

    setIsPostingComment(false);

    //if we have an attachement refresh the entire blade
    if (hasAttachment) {
      props.setReloadDetail(true);
    } else {
      setCacheBuster(true);
    }
    setNewComment('');
    stateActions.setCommentText('');
  };

  return (
    <div id="paneComments" className="flex-fill d-flex flex-column tab-pane">
      {props.detail.status != 'Closed' && (
        <form onSubmit={(e) => handleNewComment(e)}>
          <Label className="mt-3">
            <strong>New Comment</strong>
          </Label>
          <Input
            onChange={(e) => changeCommentText(e.target.value)}
            type="textarea"
            id="taNewComment"
            rows="4"
            value={newComment}
          ></Input>
          {attachments.map((attachment, i) => {
            return <div key={i}>Attached file: {attachment.name}</div>;
          })}
          <Input
            type="file"
            id="fileNewComment"
            className="mt-2 d-inline-block"
            disabled={newComment.length < 3}
            onChange={addAttachment}
            style={{ width: '95px' }}
          />
          <span>(Max File Size: 5MB)</span>
          {attachmentError && <p className="mt-2 text-danger font-italic">{attachmentError}</p>}
          <div className="text-right mt-2">
            {isPostingComment ? (
              <Button className="btn-sm" type="submit" disabled={isPostingComment}>
                <i className="fas fa-spinner fa-spin ml-1" style={{ fontSize: '15px' }}></i> Saving
              </Button>
            ) : (
              <Button className="btn-sm" type="submit" disabled={newComment.length < 3}>
                Submit
              </Button>
            )}
          </div>
        </form>
      )}
      <TicketHistories
        ticket={props.detail}
        ticketId={props.detail.id}
        cacheBuster={cacheBuster}
        setCacheBuster={setCacheBuster}
      ></TicketHistories>
      <InitialCommentDescription ticket={props.detail}></InitialCommentDescription>
    </div>
  );
};

const BladeTabs = (props) => {
  if (props.activeTab == 1) {
    return (
      <BladeTabDetail
        detail={props.detail}
        setReloadDetail={props.setReloadDetail}
        showCommentsMsg={props.showCommentsMsg ?? true}
        fullPage={props.fullPage}
      ></BladeTabDetail>
    );
  } else if (props.activeTab == 2) {
    return <BladeTabComments detail={props.detail} setReloadDetail={props.setReloadDetail}></BladeTabComments>;
  } else {
    return (
      <div id="paneFiles" className="flex-fill d-flex flex-column tab-pane">
        <TicketAttachmentList ticket={props.detail} ticketId={props.detail.id}></TicketAttachmentList>
      </div>
    );
  }
};
const InitialCommentDescription = (props) => {
  const [stateApp, stateAppActions] = appState();
  const momentTzGuess = moment.tz.guess();
  return (
    <div key={props.index} className={`mt-2 ${props.ticket.customer_id || '' > 0 ? 'text-left' : 'text-left'}`}>
      <div className="p-2 row" style={{ backgroundColor: '#e9e9e9', paddingBottom: 0 + 'px !important' }}>
        <div style={{ width: 90 + '%' }} className="col">
          <p className="  mb-0">
            Original Ticket created by:{' '}
            <span style={{ textTransform: 'capitalize', fontWeight: 700 }}>{createdBy(props.ticket.enteredby)}</span> of{' '}
            <span style={{ fontWeight: 700 }}>
              {props.ticket.enteredby.customer_id == 0 ? 'Connectria' : stateApp.userInfo.organization_name}
            </span>
          </p>
          <p className=" mb-0">
            {moment(props.ticket.created, 'YYYY-MM-DDThh:mm:ss.SSSZ').tz(momentTzGuess).format('LLL z')}
          </p>
        </div>
        <div style={{ maxWidth: 10 + '%' }} className="col center-flex-item">
          {props.customer_id == 0 ? (
            <img
              style={{ width: 30 + 'px' }}
              src="data:image/png;base64,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"
            ></img>
          ) : (
            <></>
          )}
        </div>
      </div>
      <p className="pb-3 pt-1" style={{ fontSize: 0.97 + 'rem', whiteSpace: 'pre-wrap' }}>
        <Label className="mt-1">
          <strong>Description:</strong>
        </Label>
        <div id="taDescription" style={{ whiteSpace: 'pre-wrap' }} className="mt-1 rounded mb-3">
          {props.ticket.issue}
        </div>
        {props.ticket.errorDesc.length > 0 ? (
          <>
            <Label className="mt-1">
              <strong>Error Description:</strong>
            </Label>
            <div id="taDescription" style={{ whiteSpace: 'pre-wrap' }} className="mt-1 rounded mb-3">
              {props.ticket.errorDesc}
            </div>
          </>
        ) : (
          <></>
        )}
      </p>
    </div>
  );
};

const EditTicketSubject = (props) => {
  const [subject, setSubject] = useState(props.detail.subject);
  const [editMode, setEditMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  if (['New', 'Open', 'WaitOnCust'].indexOf(props.detail.status) === -1) {
    // show basic header without editing feature
    return <h4>{props.detail.subject}</h4>;
  }

  const style = {
    border: 'solid 1px #ddd',
    borderRadius: '3px',
    padding: '5px',
    fontSize: '18px',
    marginBottom: '15px',
  };

  const save = async (e) => {
    if (props.detail.subject !== subject) {
      setEditMode(false);
      setIsLoading(true);
      await ConnectriaTicketsService.updateTicket(props.detail.id, { subject: subject });
      setIsLoading(false);

      ConnectriaTicketsService.clearTicketCache();
      props.setReloadDetail(true);
    }
  };

  if (isLoading) {
    return (
      <div className="text-center">
        <i className="fas fa-spinner m-3 mt-4 fa-spin" style={{ fontSize: '30px' }} />
      </div>
    );
  } else if (editMode) {
    return (
      <input
        value={subject}
        style={style}
        className="form-control"
        maxLength={255}
        onChange={(e) => {
          setSubject(e.target.value);
        }}
        onBlur={(e) => save(e)}
      />
    );
  } else {
    return (
      <h4 style={style} onClick={() => setEditMode(true)}>
        {props.detail.subject}
      </h4>
    );
  }
};

const ConnectriaTicketsDetailBlade = (props) => {
  //plugin state
  const [state, stateActions] = useTriaTicketsState();
  //local state
  const [isLoading, setIsLoading] = useState(true);
  const [detail, setDetail] = useState(null);
  const [activeTab, setActiveTab] = useState('1');
  const [errMsg, setErrMsg] = useState();
  const [reloadDetail, setReloadDetail] = useState(true);
  const history = useHistory();

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const source = axios.CancelToken.source();
  useAsyncEffect(
    async (isMounted) => {
      try {
        if (!reloadDetail) return;
        console.log('loading ticket details');
        setIsLoading(true);
        try {
          setDetail(await ConnectriaTicketsService.ticketDetail(props.id, { cancelToken: source.token }));
        } catch (error) {
          setErrMsg(
            <div className="text-center mt-4 text-bold">
              <i className="fas fa-exclamation-triangle"></i> Error pulling ticket #{props.id}
            </div>
          );
        }
        if (!isMounted()) return;
        setReloadDetail(false);
        setIsLoading(false);
        stateActions.setCommentText('');
      } catch (error) {
        if (axios.isCancel(error)) {
          // request cancelled
        } else {
          throw error;
        }
      }
    },
    () => {
      source.cancel();
    },
    [reloadDetail]
  );

  if (isLoading) {
    return (
      <div className="text-center">
        <i className="fas fa-spinner m-3 mt-4 fa-spin" style={{ fontSize: '30px' }}></i>
      </div>
    );
  } else if (errMsg != null) {
    return errMsg;
  } else {
    return (
      <div className="connectria-tickets-detail-blade h-100 d-flex flex-column">
        <EditTicketSubject detail={detail} setReloadDetail={setReloadDetail} />
        <ButtonGroup className="d-flex mb-2 justify-content-center" role="group">
          <Button
            onClick={() => toggleTab('1')}
            active={activeTab === '1'}
            className={`btn-sm w-100 h-100 ${activeTab !== '1' ? 'btn-simple' : ''}`}
            style={{ border: 'unset', padding: '5px 10px' }}
          >
            Details
          </Button>
          <Button
            onClick={() => toggleTab('2')}
            active={activeTab === '2'}
            className={`btn-sm w-100 h-100 ${activeTab !== '2' ? 'btn-simple' : ''}`}
            style={{ border: 'unset', padding: '5px 10px' }}
          >
            Comments
          </Button>
          <Button
            onClick={() => toggleTab('3')}
            active={activeTab === '3'}
            className={`btn-sm w-100 h-100 ${activeTab !== '3' ? 'btn-simple' : ''}`}
            style={{ border: 'unset', padding: '5px 10px' }}
          >
            Files{' '}
            <Badge
              color="secondary"
              style={{
                float: 'right',
                top: 'unset',
              }}
            >
              {detail.ticket_attachments.length}
            </Badge>
          </Button>
        </ButtonGroup>
        <BladeTabs
          activeTab={activeTab}
          detail={detail}
          setReloadDetail={setReloadDetail}
          state={state}
          history={history}
          actions={stateActions}
        ></BladeTabs>
      </div>
    );
  }
};

const NewTabLink = (props) => {
  const { value, tooltipMessage, alertMessage, idx, className, style } = props;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [text, setText] = useState(tooltipMessage);
  const toggle = () => {
    setTooltipOpen(!tooltipOpen);
    // When hovering off of tooltip, reset the message
    if (!tooltipOpen) setText(tooltipMessage);
  };
  const openNewTab = (e) => {
    e.preventDefault();
    window.open(props.link, '_blank');
    e.stopPropagation();
    return false;
  };
  return (
    <span onClick={(e) => openNewTab(e)}>
      <i
        className={'fas clickable fa-external-link-alt cursor pt-1 pl-1' + (className ? className : '')}
        id={'TooltipExample' + (idx + 1 ? idx : '')} // Index is optional
        style={{ fontSize: '0.9rem', ...style }}
      />
      <Tooltip
        placement="right"
        target={'TooltipExample' + (idx + 1 ? idx : '')} // Index is optional
        isOpen={tooltipOpen}
        toggle={toggle}
        style={{ backgroundColor: 'black', color: 'white' }}
      >
        {text}
      </Tooltip>
    </span>
  );
};
export { ConnectriaTicketsDetailBlade, BladeTabs, BladeTabDetail, BladeTabComments, NewTabLink, EditTicketSubject };
